import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import styles from "./styles/OTP.module.css";
import { useNavigate } from "react-router-dom";
import config from "../../config.js";
import { useEmployeeAuth } from "../Administrator/AdminProvider";

const base_url = config.base_url;
export function EmployeeOTP() {
  const auth = useEmployeeAuth();
  const [OTP, setOTP] = useState("");
  const [loginError, setLoginError] = useState(null);
  // const auth = useAuth()

  const navigate = useNavigate();
  useEffect(() => {
    if (!auth.hasPWD) auth.logout();
  });
  // useEffect(()=>{
  //     console.log('ha entrado')
  //     console.log(auth.userInfo)
  //     if (auth.userInfo.OTP==="true"){
  //         console.log('El usuario ya ha pasado el OTP')
  //         navigate('/user/dashboard', {replace:true});
  //     }
  // }, [auth.userInfo, navigate])
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu";
    document.body.appendChild(script);
  }, []);
  const showError = (error) => {
    setLoginError(error);
    setTimeout(() => {
      setLoginError(null);
    }, 3000);
  };
  const handleLogin = async (token) => {
    let credentials = {};
    credentials.otp = OTP;
    fetch(base_url + "admin/login/OTP", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `OTP=${OTP}&token=${token}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status !== 200) throw Error("Error");
        else return res.json();
      })
      .then((data) => {
        if (data.error) showError(data.error);
        else {
          auth.setIsAuth(true);
          auth.setIsAdmin(
            data.success.user_type === "Administrator" ? true : false
          );
          navigate("/admin/customers", { replace: true });
        }
      })
      .catch((err) => {
        console.log(err);
        showError("Error");
      });
  };
  const submitCaptcha = (e) => {
    e.preventDefault();
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
        .then((token) => {
          if (!OTP) return showError("Please provided OTP");
          handleLogin(token);
        });
    });
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      submitCaptcha(e);
    }
  };
  return (
    <div className={styles.main_div}>
      <div className={styles.title}>Employee Login</div>
      <div className={styles.main_box}>
        <div className={styles.top}>
          <div className={styles.input_text}>
            Get OTP from your MFA device
          </div>
          <input
            autoFocus
            onKeyDown={handleEnter}
            className={styles.input}
            value={OTP}
            onChange={(e) => {
              setOTP(e.target.value);
            }}
            placeholder="Insert OTP code"
          ></input>
          <button
            onClick={(e) => submitCaptcha(e)}
            className={styles.login_button}
          >
            Login
          </button>
          {loginError ? (
            <div className={styles.login_error}>{loginError}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
